import { AuthService } from '../../services/auth.service';
import { AbstractControl, AsyncValidatorFn, ValidationErrors } from '@angular/forms';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';


export function checkEmailExistsValidator(authService: AuthService) : AsyncValidatorFn {
  return (control: AbstractControl): Observable<ValidationErrors | null> => {
    const value = control.value;
    return authService.checkEmailExists(value).pipe(
      map((emailExistsInDB: boolean) => {
        return emailExistsInDB ? { emailExists: 'Sorry, This email is already associated with an account.' } : null;
    }),
    );
  };
}
